import logger from "../utils/logger";
export const openProjectModal = ({
  workspace,
  setProjectEditId,
  setProjectForm,
  setProjectModalOpen
}) => {
  if (workspace) {
    setProjectEditId(workspace.id);
    setProjectForm({
      name: workspace.name || '',
      description: workspace.description || '',
      cabinetIds: (workspace.cabinets || []).map(cabinet => cabinet.marketplace_account_id),
      ownerUserId: workspace.owner_user_id || ''
    });
  } else {
    setProjectEditId(null);
    setProjectForm({
      name: '',
      description: '',
      cabinetIds: [],
      ownerUserId: ''
    });
  }
  setProjectModalOpen(true);
};
export const closeProjectModal = setProjectModalOpen => {
  setProjectModalOpen(false);
};
export const toggleProjectCabinet = (cabinetId, setProjectForm) => {
  setProjectForm(prev => {
    const setIds = new Set(prev.cabinetIds);
    if (setIds.has(cabinetId)) {
      setIds.delete(cabinetId);
    } else {
      setIds.add(cabinetId);
    }
    return {
      ...prev,
      cabinetIds: Array.from(setIds)
    };
  });
};
export const saveProject = async ({
  event,
  projectForm,
  projectEditId,
  request,
  setBusy,
  setStatus,
  showStatus,
  loadWorkspaces,
  closeProjectModal
}) => {
  if (event) {
    event.preventDefault();
  }
  if (!projectForm.name.trim()) {
    showStatus('error', 'Введите название проекта.');
    return;
  }
  setBusy(true);
  setStatus(null);
  try {
    const payload = {
      name: projectForm.name.trim(),
      description: projectForm.description?.trim() || null,
      cabinet_ids: projectForm.cabinetIds
    };
    const requestPayload = {
      ...payload
    };
    const endpoint = projectEditId ? `/api/v1/workspaces/${projectEditId}` : '/api/v1/workspaces/';
    const method = projectEditId ? 'PATCH' : 'POST';
    logger.info(`[ProjectService] ${method} ${endpoint}`, requestPayload);
    const response = await request(endpoint, {
      method,
      body: JSON.stringify(requestPayload)
    });
    logger.info(`[ProjectService] Response:`, response);
    await loadWorkspaces();
    showStatus('success', projectEditId ? 'Проект обновлен.' : 'Проект создан.');
    closeProjectModal();
  } catch (error) {
    logger.error('[ProjectService] Error:', error);
    showStatus('error', `Не удалось сохранить проект. ${error.message || ''}`.trim());
  } finally {
    setBusy(false);
  }
};
export const handleDeleteProject = async ({
  workspaceId,
  request,
  setBusy,
  setStatus,
  showStatus,
  loadWorkspaces
}) => {
  if (!workspaceId) return;
  setBusy(true);
  setStatus(null);
  try {
    await request(`/api/v1/workspaces/${workspaceId}`, {
      method: 'DELETE'
    });
    await loadWorkspaces();
    showStatus('success', 'Проект удален.');
  } catch (error) {
    logger.error(error);
    showStatus('error', error.message || 'Не удалось удалить проект.');
  } finally {
    setBusy(false);
  }
};
export const openProjectDetail = ({
  workspaceId,
  taskFilters,
  setSavedProjectFilter,
  openProjectCard,
  setTaskFilters
}) => {
  setSavedProjectFilter(taskFilters.workspaceId);
  openProjectCard(workspaceId);
  setTaskFilters(prev => ({
    ...prev,
    workspaceId: workspaceId || ''
  }));
};
export const closeProjectDetail = ({
  savedProjectFilter,
  closeProjectCard,
  setTaskFilters
}) => {
  closeProjectCard();
  setTaskFilters(prev => ({
    ...prev,
    workspaceId: savedProjectFilter || ''
  }));
};
